<template>
  <zm-drawer
    ref="zmDrawer"
    :visible="visible"
    :title="title"
    :footer="footer"
    :okText="okText"
    :width="'55%'"
    :placement="placement"
    @cancel="cancel"
    @ok="submitForm"
    class="modal"
    id="drawerExport"
  >
    <div slot="drawerBody">
      <a-spin :spinning="loading">
        <div class="derivedMode">
          <!--          <a-col :span="12" class="radioCol">-->
          <!--            <span>导出方式</span>-->
          <!--            <a-radio-group v-model="derivedMode" class="derivedModeRadio">-->
          <!--              <a-radio :value="1">-->
          <!--                根据设备类型-->
          <!--              </a-radio>-->
          <!--              <a-radio :value="2">-->
          <!--                自选字段-->
          <!--              </a-radio>-->
          <!--            </a-radio-group>-->
          <!--          </a-col>-->
          <!--          <a-col :span="12">-->
          <!--            <span class="spanRequired">设备类型</span>-->
          <!--            <a-tree-select-->
          <!--              :getPopupContainer="(triggerNode) => triggerNode.parentNode"-->
          <!--              @change="changeEquipmentType"-->
          <!--              v-model="equipmentType"-->
          <!--              style="width: 200px;margin-left: 8px;"-->
          <!--              placeholder="请选择设备类型"-->
          <!--              allow-clear-->
          <!--              show-search-->
          <!--              :filterTreeNode="filterTreeNode"-->
          <!--              :disabled="derivedMode === 2"-->
          <!--              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"-->
          <!--              :treeData="equipmentClassList"-->
          <!--              :replaceFields="{-->
          <!--                  title: 'name',-->
          <!--                  key: 'code',-->
          <!--                  value: 'code'-->
          <!--                }"-->
          <!--            ></a-tree-select>-->
          <!--          </a-col>-->
          <a-row>
            <a-col :span="12" class="radioCol">
              <span>是否导出子设备</span>
              <a-radio-group v-model="subset" class="derivedModeRadio">
                <a-radio :value="1">
                  是
                </a-radio>
                <a-radio :value="2">
                  否
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-checkbox class="allCheckBox checkBoxGroupTitle" :checked="allChecked" :indeterminate="allIndeterminate" @change="checkAll($event)">
            全选
          </a-checkbox>
        </div>
        <div>
          <div v-for="(item, index) in checkBasicList" :key="index" class="checkModelBox checkDeviceTypeBox">
            <div class="titleDiv">
              <div class="title">
                <span class="titleName">{{ item.name }}</span>
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :indeterminate="item.indeterminate" :checked="item.checkAll" @change="fixedAllChange('checkBasicList',index, $event)">
                  全选
                </a-checkbox>
              </div>
            </div>
            <a-checkbox-group class="checkBoxGroup" v-model="item.chickList" :options="item.options" @change="fixedOnChange('checkBasicList',index, $event)">
              <span slot="label" slot-scope="{ name }">
                <a-tooltip>
                  <template slot="title">
                    {{ name }}
                  </template>
                  <span class="ellipsis">{{ name }}</span>
                </a-tooltip>
              </span>
            </a-checkbox-group>
          </div>
          <div v-for="(item, index) in checkDeviceTypeList" :key="item.name" class="checkModelBox checkDeviceTypeBox">
            <div class="titleDiv">
              <div class="title">
                <span class="titleName">{{ item.name }}</span>
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :indeterminate="item.indeterminate" :checked="item.checkAll" @change="fixedAllChange('checkDeviceTypeList',index, $event)">
                  全选
                </a-checkbox>
              </div>
            </div>
            <a-checkbox-group class="checkBoxGroup" v-model="item.chickList" :options="item.options" @change="fixedOnChange('checkDeviceTypeList',index, $event)">
              <span slot="label" slot-scope="{ name }">
                <a-tooltip>
                  <template slot="title">
                    {{ name }}
                  </template>
                  <span class="ellipsis">{{ name }}</span>
                </a-tooltip>
              </span>
            </a-checkbox-group>
          </div>
        </div>
        <div>
          <div class="titleDiv modelTitleDiv">
            <div class="title">
              <span class="titleName">自选参数字段</span>
            </div>
            <img src="@/assets/icon_addCheckModelList.png" alt="" class="addModelListIcon" @click="addCheckModel">
          </div>
          <div v-for="(item, index) in checkModelList" :key="index" class="checkModelBox">
            <div class="checkModelTop">
              <span class="spanRequired">选择参数</span>
              <a-tree-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @change="(value) => changeEquipmentParameter(value, index)"
                v-model="item.parameter"
                style="width: 200px;margin-left: 8px;"
                placeholder="请选择设备参数"
                show-search
                :filterTreeNode="filterTreeNode"
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="equipmentParameterList"
                :replaceFields="{
                  title: 'name',
                  key: 'code',
                  value: 'code'
                }"
              ></a-tree-select>
              <a-checkbox class="modelCheckAll" :indeterminate="item.indeterminate" :checked="item.checkAll" @change="fixedAllChange('checkModelList', index, $event)">
                全选
              </a-checkbox>
              <img src="@/assets/icon_del.png" alt="" class="delIcon" @click="delCheckModel(index)">
            </div>
            <a-checkbox-group class="checkBoxGroup" v-model="item.chickList" :options="item.options" @change="fixedOnChange('checkModelList', index, $event)">
              <span slot="label" slot-scope="{ name }">
                <a-tooltip>
                  <template slot="title">
                    {{ name }}
                  </template>
                  <span class="ellipsis">{{ name }}</span>
                </a-tooltip>
              </span>
            </a-checkbox-group>
          </div>
        </div>
      </a-spin>
    </div>
  </zm-drawer>
</template>

<script>
import { getEquipmentExport, getParamValuesByIsSystem } from '@/api/equipmentLedger'
import ModuleBox from '@/views/assetLedger/modules/moduleBox.vue'
import { getDeviceTypeTree } from '@/api/deviceType'
import basicCheckList from '@/views/equipmentLedger/modules/drawerExportModel/basicCheckList'
import { getDeviceParameterList, getTreeDeviceType } from '@/api/deviceParameter'
export default {
  components: { ModuleBox },
  props: {
    // 气体设备用到的
    searchDeviceType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: true,
      okText: '导出',
      placement: 'right',
      loading: false,
      btnLoading: false,
      // 导出方式
      derivedMode: 1,
      // 是否导出子设备
      subset: 1,
      // 设备类型列表
      equipmentClassList: [],
      // 设备参数列表
      equipmentParameterList: [],
      checkBasicList: [
        {
          name: '基本信息',
          indeterminate: null,
          checkAll: false,
          options: basicCheckList,
          chickList: []
        }
      ],
      checkDeviceTypeList: [],
      checkModelList: [],
      // 顶部全选
      allChecked: false,
      allIndeterminate: false,
      // 设备类型
      equipmentType: undefined,
      searchModel: {}
    }
  },
  created () {
    this.getEquipmentClassList()
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.searchModel = model
    },
    // setEquipmentType (code) {
    //   if (code && code !== '设备分类' && code !== '空') {
    //     this.equipmentType = code
    //   } else {
    //     this.equipmentType = undefined
    //   }
    // },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        this.changeEquipmentType()
        this.getDeptData()
      }
      this.visible = flag
    },
    // 获取设备类别
    getEquipmentClassList () {
      const data = {}
      if (this.searchDeviceType) {
        data.code = this.searchDeviceType
      }
      getDeviceTypeTree(data).then(res => {
        if (res.status === 0) {
          this.equipmentClassList = res.data
        }
      })
    },
    // 改变设备类型
    changeEquipmentType () {
      // 删除checkDeviceTypeList数组中除了下标是0的其他元素，重置
      this.checkDeviceTypeList = []
      const deviceTypeList = []
      this.loading = true
      getParamValuesByIsSystem().then(res => {
        if (res.status === 0) {
          for (const item of res.data) {
            const obj = {
              name: item.pName,
              indeterminate: null,
              checkAll: null,
              options: [],
              chickList: []
            }
            for (const childItem of item.children) {
              obj.options.push({
                name: childItem.name,
                value: childItem.value + ';' + childItem.name
              })
            }
            deviceTypeList.push(obj)
          }
          this.checkDeviceTypeList = deviceTypeList
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
        .catch(err => {
          this.loading = false
        })
    },
    // 搜索设备类型
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 获取设备参数
    async getDeptData () {
      const data = {
        pCode: 'EQUIPMENT_PARAM',
        dimName: ''
      }
      getTreeDeviceType(data).then(res => {
        if (res.status === 0) {
          this.equipmentParameterList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 改变设备参数
    changeEquipmentParameter (value, index) {
      this.getCheckList(value, index)
      this.findEquipmentParameterDisabled()
    },
    // 获取自选参数字段的checkList
    getCheckList (value, index) {
      const data = {
        typeCode: value,
        paging: false
      }
      this.checkModelList[index].chickList = []
      this.checkModelList[index].checkAll = false
      getDeviceParameterList(data).then(res => {
        if (res.status === 0) {
          if (res.data) {
            res.data.forEach(item => {
              item.value = item.value + ';' + item.name
            })
            this.checkModelList[index].options = res.data
            if (index === this.checkModelList.length - 1) {
              const dom = document.getElementById('drawerExport').getElementsByClassName('drawer_body')[0]
              this.$nextTick(() => {
                dom.scrollTop = dom.scrollHeight
              })
            }
            if (res.data.length > 0) {
              this.verdictCheckAll()
            }
          } else {
            this.checkModelList[index].options = []
          }
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 新增自选参数字段
    addCheckModel () {
      this.checkModelList.push({
        indeterminate: null,
        checkAll: false,
        options: [],
        chickList: [],
        parameter: undefined
      })
      const dom = document.getElementById('drawerExport').getElementsByClassName('drawer_body')[0]
      this.$nextTick(() => {
        dom.scrollTop = dom.scrollHeight
      })
    },
    // 删除自选参数字段
    delCheckModel (index) {
      this.checkModelList.splice(index, 1)
      this.verdictCheckAll()
      this.findEquipmentParameterDisabled()
    },
    // 遍历自选参数字段并设置disabled
    async findEquipmentParameterDisabled () {
      // 写一个方法，用于遍历equipmentParameterList树，并且根据传入的code参数，设置disabled，code相同时disabled为true
      function findEquipmentParameterDisabled (tree, code) {
        tree.forEach(item => {
          item.disabled = code.indexOf(item.code) > -1
          if (item.children) {
            findEquipmentParameterDisabled(item.children, code)
          }
        })
      }
      const codeList = []
      for await (const item of this.checkModelList) {
        if (item.parameter) {
          codeList.push(item.parameter)
        }
      }
      findEquipmentParameterDisabled(this.equipmentParameterList, codeList)
      this.$forceUpdate()
    },
    // 固定模块字段选中
    fixedOnChange (listName, index, checkedList) {
      this[listName][index].indeterminate = !!checkedList.length && checkedList.length < this[listName][index].options.length
      this[listName][index].checkAll = checkedList.length === this[listName][index].options.length
      this.verdictCheckAll()
      this.$forceUpdate()
    },
    // 固定模块字段全选
    fixedAllChange (listName, index, e) {
      const plainOptions = []
      this[listName][index].options.forEach(item => {
        plainOptions.push(item.value)
      })
      this[listName][index].chickList = e.target.checked ? plainOptions : []
      this[listName][index].checkAll = e.target.checked
      this[listName][index].indeterminate = false
      this.verdictCheckAll()
      this.$forceUpdate()
    },
    // 全选
    checkAll (e) {
      // 基础信息全选
      this.fixedAllChange('checkBasicList', 0, e)
      this.checkDeviceTypeList.forEach((item, index) => {
        this.fixedAllChange('checkDeviceTypeList', index, e)
      })
      this.checkModelList.forEach((item, index) => {
        this.fixedAllChange('checkModelList', index, e)
      })
      this.allChecked = e.target.checked
      this.allIndeterminate = false
      this.$forceUpdate()
    },
    // 判断是否全部选中，从而改变全选的状态
    verdictCheckAll () {
      if (this.checkBasicList[0].checkAll && this.checkDeviceTypeList.every(item => item.checkAll) && this.checkModelList.every(item => item.checkAll)) {
        this.allChecked = true
        this.allIndeterminate = false
      } else if (this.checkBasicList[0].checkAll || this.checkDeviceTypeList.every(item => item.checkAll) || this.checkModelList.every(item => item.checkAll)) {
        this.allChecked = false
        this.allIndeterminate = true
      } else {
        this.allChecked = false
        this.allIndeterminate = false
      }
    },
    // 导出
    submitForm () {
      try {
        this.checkModelList.forEach(item => {
          if (!item.parameter) {
            throw new Error('请选择自选参数字段')
          }
        })
      } catch (err) {
        this.$message.error(err.message)
        return
      }
      this.$refs.zmDrawer.handleOkLoading(true)
      const params = {
        ...this.searchModel
      }
      // 判断是否要传pid
      if (params.hasOwnProperty('pid')) {
        if (this.subset === 1) {
          delete params.pid
        }
      }
      params.colKeys = []
      params.headNames = []
      // 合并checkModelList,checkDeviceTypeList和checkBasicList三个数组为一个新数组
      let checkList = []
      // if (this.derivedMode === 1) {
      //   checkList = [...this.checkBasicList, ...this.checkDeviceTypeList]
      // } else {
      checkList = [...this.checkBasicList, ...this.checkDeviceTypeList, ...this.checkModelList]
      // }
      for (const item of checkList) {
        for (const item2 of item.chickList) {
          const arr = item2.split(';')
          params.colKeys.push(arr[0])
          params.headNames.push(arr[1])
        }
      }
      getEquipmentExport(params).then(res => {
        var blob = new Blob([res])
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = '设备列表.xls'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
        this.$refs.zmDrawer.handleOkLoading(false)
        this.cancel()
      }).catch(err => {
        this.$refs.zmDrawer.handleOkLoading(false)
      })
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        this.loading = false
        this.btnLoading = false
        this.searchModel = {}
        this.checkBasicList = [
          {
            name: '基本信息',
            indeterminate: null,
            checkAll: false,
            options: basicCheckList,
            chickList: []
          }
        ]
        this.checkDeviceTypeList = []
        this.checkModelList = []
        this.equipmentType = undefined
        this.derivedMode = 1
        this.subset = 1
        this.allChecked = false
        this.allIndeterminate = false
      })
    }
  }
}
</script>
<style lang="less">
.derivedMode {
  padding-bottom: 16px;
  .radioCol {
    display: flex;
    align-items: center;
    height: 32px;
  }
  .derivedModeRadio {
    margin-left: 12px;
    display: flex;
    .ant-radio-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 10px;
  .titleName{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: rgba(8, 64, 159, 1);
    margin-right: 12px;
  }
  .addModelListIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
.modelTitleDiv {
  width: 100%;
  padding-top: 9px;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
  border-bottom: 1px solid rgba(241, 241, 241, 1);
}
.checkModelBox {
  border-bottom: 1px solid rgba(241, 241, 241, 1);
  padding-top: 9px;
  .checkBoxGroup {
    display: grid;
    grid-template-columns: repeat(5, calc((100% - 100px )/ 5));
    grid-column-gap: 28px;
    //grid-row-gap: 16px;
    .ant-checkbox-group-item {
      margin-bottom: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .ellipsis {
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .ant-checkbox-group-item >span:nth-child(2) {
      width: calc(100% - 12px);
    }
  }
  .checkModelTop {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    .modelCheckAll {
      margin-left: 12px;
    }
    .delIcon {
      margin-left: auto;
      margin-right: 12px;
      cursor: pointer;
    }
  }
}
.checkDeviceTypeBox:nth-child(1) {
  border-top: 1px solid rgba(241, 241, 241, 1);
}
.spanRequired:before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 12px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.ant-checkbox + span{
  padding-left: 4px;
}
.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner::after {
  left: 20% !important;
}
.ant-checkbox-wrapper .ant-checkbox-indeterminate .ant-checkbox-inner::after {
  top: 46% !important;
}
</style>
